export default "__VITE_ASSET__DCeSQh8Q__"